<template>
<div class="chapter">
<div class="inner_page">
<p class="otherfm1"><a id="page_iv">A<span class="small">LSO BY</span> K<span class="small">AREN</span> H<span class="small">AWKINS</span></a></p><a id="page_iv">
<p class="center1">T<span class="small">HE</span> H<span class="small">URST</span> A<span class="small">MULET</span> S<span class="small">ERIES</span><br/><em>One Night in Scotland</em></p>
<p class="center1">T<span class="small">HE</span> M<span class="small">ACLEAN</span> C<span class="small">URSE</span> S<span class="small">ERIES</span><br/><em>How to Abduct a Highland Lord<br/>To Scotland, With Love<br/>To Catch a Highlander<br/>Sleepless in Scotland<br/>The Laird Who Loved Me</em></p>
<p class="center1">P<span class="small">REQUEL TO THE</span> H<span class="small">URST</span> A<span class="small">MULET<br/>AND</span> M<span class="small">ACLEAN</span> C<span class="small">URSE</span> S<span class="small">ERIES</span><br/><em>Much Ado About Marriage</em></p>
<p class="center1">C<span class="small">ONTEMPORARY</span> R<span class="small">OMANCE</span><br/><em>Talk of the Town<br/>Lois Lane Tells All</em></p>
<p class="centerc1">Available from Pocket Books</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm1.vue?794ea8e8